/* GG · Product · Upsell — one-click add to cart, lands in the cart drawer
   without a page reload. Mirrors Dawn's own product-form.js fetch pattern
   exactly (same endpoint, same "sections" trick, same cart-drawer render),
   so it reuses proven cart logic instead of a bespoke implementation. */
(function () {
  'use strict';

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    var label = btn.querySelector('[data-gg-upsell-add-label]');
    var originalLabel = label ? label.textContent : '';
    btn.disabled = true;
    if (label) label.textContent = '···';

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    var config = fetchConfig('json');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          console.error('[GG Upsell] Cart add error:', response.description || response.message);
          if (label) label.textContent = originalLabel;
          btn.disabled = false;
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }
        btn.classList.add('is-added');
        if (label) label.textContent = '✓';
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label) label.textContent = originalLabel;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function (err) {
        console.error('[GG Upsell] Cart add failed:', err);
        if (label) label.textContent = originalLabel;
        btn.disabled = false;
      });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-gg-upsell-add]')).forEach(function (btn) {
      btn.addEventListener('click', function () { addToCart(btn); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
